(ns iris.tags.events
  (:require
   [re-frame.core :as re-frame]
   [ajax.core :as ajax]
   [iris.utils :as utils]
   [iris.events :as events]
   [iris.posts.events :as posts-events]
   [iris.tags.common :as tags-common]
   [iris.indexeddb :as idb]
   [iris.globals :as globals]))

;;;;;;;;;;;;;;;;;;;;;;;
;; commtags
;;;;;;;;;;;;;;;;;;;;;;;

(re-frame/reg-event-db
 ::reset-community-tags-api-response
 (fn [db [_]]
   (assoc-in db [:community-tags-api-response] nil)))

(re-frame/reg-event-db
 ::http-set-community-tags-success
 [(events/api-msg-interceptor {})]
 (fn [db [_ ruid data]]


   (println "http-set-community-tags-success:" data)
   ;;  (re-frame/dispatch [::posts-events/http-reload-post ruid])
   (re-frame/dispatch [::posts-events/update-posts-data-row ruid (get-in data [:result :data])])

   (re-frame/dispatch [::events/set-loading false])

   (-> db
       ;;  (assoc-in
       ;;   [:message]
       ;;   (or (get-in data [:result :message]) (get-in data [:error :message])))

       (assoc-in
        [:community-tags-api-response :result-message]
        (get-in data [:result :message]))

       (assoc-in
        [:community-tags-api-response :error-message]
        (get-in data [:error :message])))))


(re-frame/reg-event-db
 ::http-set-community-tags-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::events/set-loading false])
   ;;  (re-frame/dispatch [::http-complete])
   ;;  (-> db
   ;;      ;;  (assoc-in [:posts :message] "API connection failure!")
   ;;      (assoc-in [:message] "API connection failure!"))
   db))


(re-frame/reg-event-fx
 ::http-set-community-tags
 (fn [e [_ ruid tags]]
   (re-frame/dispatch [::reset-community-tags-api-response])
   (let [data {:ruid ruid :tags tags}]
     (events/post-rpc {:jsonrpc "2.0"
                       :id 0
                       ;;  :method "Post.SetCommunityTags"
                       :method "Post2a.SetCommunityTags"
                       :params {:options {:debug false}
                                :data data}}
                      [::http-set-community-tags-success ruid]
                      [::http-set-community-tags-failure]))))



(re-frame/reg-event-db
 ::set-modal-display
 (fn [db [_ status]]
   (assoc-in db [:tags :modal :display] status)))

(re-frame/reg-event-db
 ::set-row-selected
 (fn [db [_ ruid status]]
   (assoc-in db [:tags :data ruid :selected] status)))

(re-frame/reg-event-db
 ::set-all-rows-selected
 (fn [db [_ status]]
   ;; (reduce (fn [db [index d]] (assoc-in db [:tags :data index :selected] status)) db (get-in db [:tags :data]))
   (reduce (fn [db [index d]]
             ;;  cond order-tags are already set (the row has been selected before), just set selected status
             ;;  :else set order-tags (the row is being selected for the first time)
             ;;  this way the selection of chips and ordering won't be messed up if the row is selected on and off
             ;;  NOTE/TODO: we could also dispatch the set-order-tags event OR refactor these two functions so the logic is not repeated
             (cond (:order-tags d)
                   (assoc-in db [:tags :data index :selected] status)
                   :else
                   (let [tags (map #(hash-map :tag % :selected false :approved true) (:tags d))
                         new-tags (map #(hash-map :tag % :selected false :approved false) (:new-tags d))
                         order-tags (vec (concat tags new-tags))]
                     (-> db
                         (assoc-in [:tags :data index :selected] status)
                         (assoc-in [:tags :data index :order-tags] order-tags)))))
           db
           (get-in db [:tags :data]))))

(re-frame/reg-event-db
 ::set-selection-kv
 (fn [db [_ k v]]
   (assoc-in db [:tags :selection k] v)))

(re-frame/reg-event-db
 ::set-order-tags
 (fn [db [_ index tags new-tags]]
   (let [tags (map #(hash-map :tag % :selected false :approved true) tags)
         new-tags (map #(hash-map :tag % :selected false :approved false) new-tags)]
     (assoc-in db [:tags :data index :order-tags] (vec (concat tags new-tags))))))

(re-frame/reg-event-db
 ::update-order-tags
 (fn [db [_ tags-data-index order-data-index update-data]]
   ;;  (let [order-tags (get-in db [:tags :data tags-data-index :order-tags])
   ;;        updated-order-tags (update-in order-tags [order-data-index] merge update-data)]
   ;;    (assoc-in db [:tags :data tags-data-index :order-tags] updated-order-tags)
   ;;    (update-in db [:tags :data tags-data-index :order-tags order-data-index] merge update-data))
   (update-in db [:tags :data tags-data-index :order-tags order-data-index] merge update-data)))


(re-frame/reg-event-db
 ::remove-order-tags
 (fn [db [_ tags-data-index order-data-index]]
   (update-in db [:tags :data tags-data-index :order-tags] #(vec (concat (subvec % 0 order-data-index) (subvec % (inc order-data-index)))))))


(re-frame/reg-event-db
 ::move-up-selected-order-tags
 (fn [db [_ tags-data-index]]
   (let [order-tags (get-in db [:tags :data tags-data-index :order-tags])
         ;;  updated-order-tags (loop [v order-tags
         ;;                            i 0]
         ;;                       (if (< i (count v))
         ;;                         (let [current-map (get v i)]
         ;;                           (if (:selected current-map)
         ;;                             ;; move up (if not at the start)
         ;;                             (let [new-index (max 0 (dec i))]
         ;;                               ;; Swap the selected element with the new index
         ;;                               (recur (assoc v i (get v new-index) new-index (get v i)) (inc i)))
         ;;                             ;; No selected, just move to next element
         ;;                             (recur v (inc i))))
         ;;                         v))
         updated-order-tags (tags-common/move-up-tags order-tags)]
     (assoc-in db [:tags :data tags-data-index :order-tags] updated-order-tags))))


(re-frame/reg-event-db
 ::move-down-selected-order-tags
 (fn [db [_ tags-data-index]]
   (let [order-tags (get-in db [:tags :data tags-data-index :order-tags])
         ;;  updated-order-tags (loop [v order-tags
         ;;                            i (dec (count v))]
         ;;                       (if (>= i 0)
         ;;                         (let [current-map (get v i)]
         ;;                           (if (:selected current-map)
         ;;                             ;; move down (if not at the end)
         ;;                             (let [new-index (min (dec (count v)) (inc i))]
         ;;                               ;; Swap the selected element with the new index
         ;;                               (recur (assoc v i (get v new-index) new-index (get v i)) (dec i)))
         ;;                             ;; No selected, just move to next element
         ;;                             (recur v (dec i))))
         ;;                         v))
         updated-order-tags (tags-common/move-down-tags order-tags)]
     (assoc-in db [:tags :data tags-data-index :order-tags] updated-order-tags))))


(re-frame/reg-event-db
 ::move-selected-order-tags-to-end
 (fn [db [_ tags-data-index]]
   (let [order-tags (get-in db [:tags :data tags-data-index :order-tags])
         ;;  selected-tags (filter :selected order-tags)
         ;;  unselected-tags (filter #(not (:selected %)) order-tags)
         updated-order-tags (tags-common/move-to-end-tags order-tags)]
     ;;  (assoc-in db [:tags :data tags-data-index :order-tags] (vec (concat unselected-tags selected-tags)))
     (assoc-in db [:tags :data tags-data-index :order-tags] updated-order-tags))))


(re-frame/reg-event-db
 ::move-selected-order-tags-to-start
 (fn [db [_ tags-data-index]]
   (let [order-tags (get-in db [:tags :data tags-data-index :order-tags])
         ;;  selected-tags (filter :selected order-tags)
         ;;  unselected-tags (filter #(not (:selected %)) order-tags)
         updated-order-tags (tags-common/move-to-start-tags order-tags)]
     ;;  (assoc-in db [:tags :data tags-data-index :order-tags] (vec (concat selected-tags unselected-tags)))
     (assoc-in db [:tags :data tags-data-index :order-tags] updated-order-tags))))

(re-frame/reg-event-db
 ::deselected-all-order-tags
 (fn [db [_ tags-data-index]]
   (let [order-tags (get-in db [:tags :data tags-data-index :order-tags])
         ;;  selected-tags (filter :selected order-tags)
         ;;  unselected-tags (filter #(not (:selected %)) order-tags)
         updated-order-tags (tags-common/deselect-all-tags order-tags)]
     ;;  (assoc-in db [:tags :data tags-data-index :order-tags] (vec (concat selected-tags unselected-tags)))
     (assoc-in db [:tags :data tags-data-index :order-tags] updated-order-tags))))


(re-frame/reg-event-db
 ::approve
 (fn [db [_ index]]
   ;; extract vector of :tag properties from :order-tags to be sent to server
   ;;  (let [order-tags (get-in db [:tags :data index :order-tags])
   ;;        tags (mapv :tag (filter :tag order-tags))]
   ;;    (when (some? tags)
   ;;      (println (str index " approving tags: " tags))))
   (if-let [order-tags (get-in db [:tags :data index :order-tags])]
     (let [tags (mapv :tag (filter :tag order-tags))]
       (when (some? tags)
         (println (str index " approving tags from order-tags: " tags))))
     (let [tags (concat (get-in db [:tags :data index :tags]) (get-in db [:tags :data index :new-tags]))]
       (when (some? tags)
         (println (str index " approving tags from tags+new-tags: " tags)))))
   ;; remove pending submission from the list
   (update-in db [:tags :data] dissoc index)))



(re-frame/reg-event-db
 ::approve-tags
 (fn [db [_ indexes]]
   (println "Approving:"
            (reduce (fn [new-map index]
                      (if-let [order-tags (get-in db [:tags :data index :order-tags])]
                        (let [tags (mapv :tag (filter :tag order-tags))]
                          (when (some? tags)
                            (println (str index " approving tags from order-tags: " tags))
                            (assoc new-map index tags)))
                        (let [tags (into [] (concat (get-in db [:tags :data index :tags]) (get-in db [:tags :data index :new-tags])))]
                          (when (some? tags)
                            (println (str index " approving tags from tags+new-tags: " tags))
                            (assoc new-map index tags)))))
                    {}
                    indexes))
   (assoc-in db [:tags :data] (reduce dissoc (get-in db [:tags :data]) indexes))))

(re-frame/reg-event-db
 ::set-columns
 (fn [db [_ list k p v]]
   (assoc-in db [:tags :columns list k p] v)))


;; TODO: add block-tags/reject tags event

(re-frame/reg-event-db
 ::reject
 (fn [db [_ index]]
   (println "Rejecting::" index)
   ;; remove pending submission from the list
   (update-in db [:tags :data] dissoc index)))


(re-frame/reg-event-db
 ::reject-tags
 (fn [db [_ indexes]]
   (println "Rejecting::" indexes)
   (assoc-in db [:tags :data] (reduce dissoc (get-in db [:tags :data]) indexes))))




;;;;;;;;;;;;;;;;;
;; Autotags
;;;;;;;;;;;;;;;;;


(re-frame/reg-fx
 :set-autotags-cache
 (fn [[ws data]]  ;; note vector destructuring
   (idb/set-autotags-cache! ws data)))


(re-frame/reg-fx
 :set-globals-autotags
 (fn [data]
   (reset! globals/autotags data)))


(re-frame/reg-event-fx
 ::set-autotags
 (fn [{:keys [db]} [_ data]]
   {:set-globals-autotags data
    ;; :db (assoc db :autotags data) ;; not used at the moment, can turn off
    }))


(re-frame/reg-event-fx
 ::http-get-autotags-list-success
 [(events/api-msg-interceptor {:result-modifier-fn (fn [msg] (str msg ". Load AutoTags.List"))})]
 (fn [{:keys [db]} [_ ws data]]
   (if-let [data (get-in data [:result :data])]
     {:set-autotags-cache [ws data] ;; single arg: vector
      :dispatch-n [[::set-autotags data]
                   [::events/set-loading false]]}
     {})))


(re-frame/reg-event-db
 ::http-get-autotags-list-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::events/set-loading false])
   db))


(re-frame/reg-event-fx
 ::http-get-autotags-list
 (fn [{:keys [db]} [_ jwt ws]]
   {:http-xhrio (events/track-http-xhrio
                 "AutoTags.List"
                 {:method :post
                  :uri js/hermesURL
                  :body (utils/clj->json
                         {:jsonrpc "2.0"
                          :id 0
                          :method "AutoTags.List"})
                  :timeout 60000
                  :headers [:Authorization (str "Bearer " jwt)]
                  :response-format (ajax/json-response-format {:keywords? true})
                  :on-success      [::http-get-autotags-list-success ws]
                  :on-failure      [::http-get-autotags-list-failure]})
    :dispatch [::events/set-loading true]}))



;; AutoTags.ListFresh
(re-frame/reg-event-fx
 ::http-get-autotags-list-fresh-success
 [(events/api-msg-interceptor {:result-modifier-fn (fn [msg] (str msg ". Load AutoTags.ListFresh"))})]
 (fn [{:keys [db]} [_ ws data]]
   (if-let [data (get-in data [:result :data])]
     {:set-autotags-cache [ws data] ;; single arg: vector
      :dispatch-n [[::set-autotags data]
                   [::events/set-loading false]]}
     {})))


(re-frame/reg-event-db
 ::http-get-autotags-list-fresh-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::events/set-loading false])
   db))


(re-frame/reg-event-fx
 ::http-get-autotags-list-fresh
 (fn [{:keys [db]} [_ jwt ws]]
   {:http-xhrio (events/track-http-xhrio
                 "AutoTags.ListFresh"
                 {:method :post
                  :uri js/hermesURL
                  :body (utils/clj->json
                         {:jsonrpc "2.0"
                          :id 0
                          :method "AutoTags.ListFresh"})
                  :timeout 60000
                  :headers [:Authorization (str "Bearer " jwt)]
                  :response-format (ajax/json-response-format {:keywords? true})
                  :on-success      [::http-get-autotags-list-fresh-success ws]
                  :on-failure      [::http-get-autotags-list-fresh-failure]})
    :dispatch [::events/set-loading true]}))


(re-frame/reg-event-fx
 ::load-autotags-list
 (fn [{:keys [db]} [_ jwt ws]]
   (idb/get-autotags-cache!
    ws
    (fn [{:keys [timestamp data] :as cached}]
      (let [now (.now js/Date)
            expired? (or (nil? cached)
                         (> (- now timestamp) idb/autotags-cache-expiry-ms))]
        (if expired?
          (re-frame/dispatch [::http-get-autotags-list jwt ws])
          (do
            (re-frame/dispatch [::set-autotags data])
            (re-frame/dispatch [::events/add-msg {:info [:span "AutoTags.List loaded from cache "
                                                         [:a {:href "#"
                                                              :on-click (fn [e]
                                                                          (.preventDefault e)
                                                                          (println "Load AutoTags.ListFresh")
                                                                          (re-frame/dispatch [::http-get-autotags-list-fresh jwt ws]))} "Reload?"]]}]))))))
   {}))


;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; ;; Autotags AI
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;


(re-frame/reg-event-db
 ::set-ai-tags
 (fn [db [_ post-id source data]]
   (-> db
       (assoc-in [:ai-tags post-id source] data))))


(re-frame/reg-event-fx
 ::fetch-ai-tags-success
 [(events/api-msg-interceptor {})]
 (fn [{:keys [db]} [_ post-id source data]]
   (if-let [data (get-in data [:result :data])]
     {:dispatch-n [[::set-ai-tags post-id source data]
                   [::events/set-loading false]]}
     {})))


(re-frame/reg-event-db
 ::fetch-ai-tags-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::events/set-loading false])
   db))


(re-frame/reg-event-fx
 ::fetch-ai-tags
 (fn [{:keys [db]} [_ post-id source]]

   (if-let [post (-> (filter #(= post-id (:id %)) (get-in db [:posts :data]))
                     (first))]
     (let [company (:board_name post)
           body (-> (get-in post [:content :body])
                    (utils/strip-html))
           title (-> (get-in post [:content :title])
                     (utils/strip-html))
           methods {:chatgpt1 "GetOpenAi1"
                    :chatgpt2 "GetOpenAi2"
                    :chatgpt3 "GetOpenAi3"}
           method (get methods source)]
       {:http-xhrio (events/track-http-xhrio
                     (str "AutoTags." method)
                     {:method :post
                      :uri js/hermesURL
                      :body (utils/clj->json
                             {:jsonrpc "2.0"
                              :id 0
                              :method (str "AutoTags." method)
                              :params {:options {:debug false}
                                       :data {:title title
                                              :body body
                                              :company company}}})
                      :timeout 60000
                      :headers [:Authorization (str "Bearer " globals/jwt)]
                      :response-format (ajax/json-response-format {:keywords? true})
                      :on-success      [::fetch-ai-tags-success post-id source]
                      :on-failure      [::fetch-ai-tags-failure]})
        :dispatch [::events/set-loading true]})
     {})))


(re-frame/reg-event-db
 ::clear-ai-tags
 (fn [db [_ post-id]]
   (update db :ai-tags dissoc post-id)))

(re-frame/reg-event-db
 ::remove-ai-tag
 (fn [db [_ post-id service tag]]
   (update-in db [:ai-tags post-id service] #(vec (remove #{tag} %)))))
